import { memo } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from '@shopify/polaris';
import { accountSelector } from '@/redux/features/plan.slice';
import { AccountPlan } from '@/constants/enum';
import { usePlanDisplayName } from '@/hooks/usePlanDisplayName';
import AssistantIcon from './AssistantIcon';
import { StyledButton, IconWrapper } from './styled';

interface TrakowAssistantButtonProps {
  onClick?: () => void;
  loading?: boolean;
  forceDisabled?: boolean;
  className?: string;
  showUpgradeTooltip?: boolean;
  size?: 'sm' | 'default' | 'lg';
  allowForStarter?: boolean;
}

const TrakowAssistantButton = ({
  onClick,
  loading = false,
  forceDisabled = false,
  className,
  showUpgradeTooltip = true,
  size = 'default',
  allowForStarter = false,
}: TrakowAssistantButtonProps) => {
  const { plan } = useSelector(accountSelector);
  const { getPlanName } = usePlanDisplayName();
  const isRestrictedPlan = !allowForStarter && plan === AccountPlan.Starter;
  const isDisabled = isRestrictedPlan || forceDisabled || loading;

  const button = (
    <StyledButton
      $disabled={isDisabled}
      $loading={loading}
      $size={size}
      className={className}
      disabled={isDisabled}
      onClick={onClick}
      aria-label="Trakow Assistant"
      type="button"
    >
      <IconWrapper>
        <AssistantIcon color={isDisabled ? 'rgba(0, 0, 0, 0.5)' : '#FFFFFF'} />
      </IconWrapper>
      <span>Trakow Assistant</span>
    </StyledButton>
  );

  if (isRestrictedPlan && showUpgradeTooltip) {
    return (
      <Tooltip
        content={`This feature is available on the ${getPlanName(
          AccountPlan.Basic,
        )} plan or higher. Upgrade to use Trakow Assistant.`}
      >
        <div style={{ display: 'inline-block' }}>{button}</div>
      </Tooltip>
    );
  }

  return button;
};

export default memo(TrakowAssistantButton);
